module.exports = __webpack_public_path__ + "media/Serenity of Two Hearts.56343017.mp3";